module.exports = __webpack_public_path__ + "fd1-b5c8ae85dff12ddb6bfeda0e8b305717.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/fd1.png
// module id = +uOv
// module chunks = client